let numberAcross=8;   // 8.5" paper
//let numberAcross=5;   // 6" paper
let maxNumRowsPerPage=25;

let left=0;
let top=0;

let factor=.50;
let octagon1=13*factor;
let octagon2=40*factor;
let octagon4=110*factor;
let font=45*factor;
let numberOffsetX=0;
let numberOffsetY=0;
let border=3;
let spaceBetweenNumbers=3;
let borderFactor=1;
let labelWidth=((octagon4+spaceBetweenNumbers)*2)+10;
//let canvasWidth=(((octagon4+spaceBetweenNumbers)*numberAcross*2)+octagon1)+(border*(borderFactor*3));
let center=(octagon4+octagon1)/2;
let align=center+(15*factor);

function getCell(num){

    // print octagon
    /*
    let result= `
        <polygon
            fill="white"
            points="${left+octagon2} ${top+octagon1}, ${left+octagon3} ${top+octagon1}, ${left+octagon4} ${top+octagon2}, ${left+octagon4} ${top+octagon3}, ${left+octagon3} ${top+octagon4}, ${left+octagon2} ${top+octagon4}, ${left+octagon1} ${top+octagon3}, ${left+octagon1} ${top+octagon2}"
        />
    `;
    */

   // print circle
   let result=`
    <circle
        cx="${left+(octagon4/2)+(octagon1/2)}" 
        cy="${top+(octagon4/2)}"
        r="${octagon2+5}"
        fill="white"
    />
   `;

   // print number
   result+= `
        <text x="${left+center+numberOffsetX}" y="${top+align+numberOffsetY}" font-family="Super Sans" font-weight="bold" text-anchor="middle" fill="black" font-size="${font}">${num}</text>
   `;

   // print underline if necessary
    let underline = num.toString().replaceAll("6","").replaceAll("9","").replaceAll("0","");
    if(underline.length===0){
        underline = num.toString().replaceAll("6","_").replaceAll("9","_").replaceAll("0","");
        result+=`
        <text x="${left+center+numberOffsetX}" y="${top+align+numberOffsetY}" font-weight="bold" text-anchor="middle" fill="black" font-size="${font}">${underline}</text>
        `;
    }
    return result;
}

function getLabel(obj){
    //let orig=`o:${obj.left_original_major}/${obj.left_original_minor} - ${obj.right_original_major}/${obj.right_original_minor}`
    let result= `
        <rect
            fill="white"
            x="${left+spaceBetweenNumbers}"
            y="${top}"
            width="${labelWidth}" 
            height="${octagon4}"
        />
        <text x="${left+numberOffsetX+(spaceBetweenNumbers*2)}" y="${top+(align/1.7)+numberOffsetY}" font-family="Super Sans" font-weight="bold" text-anchor="left" fill="black" font-size="${font/1.25}">${obj.major}/${obj.minor}</text>
        <text x="${left+numberOffsetX+(spaceBetweenNumbers*2)}" y="${top+(align/.85)+numberOffsetY}" font-family="Super Sans" font-weight="bold" text-anchor="left" fill="black" font-size="${font/1.25}">${obj.barcode}</text>
        <text x="${left+numberOffsetX+(spaceBetweenNumbers*2)+(octagon4*1)}" y="${top+(align/1.0)+numberOffsetY}" font-family="Super Sans" font-weight="bold" text-anchor="left" fill="black" font-size="${font/2}">l:${obj.left_original_major}/${obj.left_original_minor}</text>
        <text x="${left+numberOffsetX+(spaceBetweenNumbers*2)+(octagon4*1)}" y="${top+(align/.80)+numberOffsetY}" font-family="Super Sans" font-weight="bold" text-anchor="left" fill="black" font-size="${font/2}">r:${obj.right_original_major}/${obj.right_original_minor}</text>
    `;
    return result;
}

function getObjectStart(canvasWidth,canvasHeight){
    let result = `
        <svg xmlns="http://www.w3.org/2000/svg" 
        width="${canvasWidth-border}"
        height="${canvasHeight-border}"
        >`

    // add border
    //result += `<rect x="${border}" y="${border}" width="${border}" height="${canvasHeight-(2*border)}" fill="white" />`;
    //result += `<rect x="${border}" y="${border}" width="${canvasWidth-(2*border)}" height="${border}" fill="white" />`;
    //result += `<rect x="${canvasWidth-(2*border)}" y="${border}" width="${border}" height="${canvasHeight-(2*border)}" fill="white" />`;
    //result += `<rect x="${border}" y="${canvasHeight-(2*border)}" width="${canvasWidth-(2*border)}" height="${border}" fill="white" />`;

    result += `<rect x="0" y="0" width="${border}" height="${canvasHeight-(2*border)}" fill="white" />`;
    result += `<rect x="0" y="0" width="${canvasWidth-(2*border)}" height="${border}" fill="white" />`;
    result += `<rect x="${canvasWidth-(2*border)}" y="0" width="${border}" height="${canvasHeight-(2*border)}" fill="white" />`;
    result += `<rect x="0" y="${canvasHeight-(2*border)}" width="${canvasWidth-(1*border)}" height="${border}" fill="white" />`;

    return result;        

}

export function printSequence(startNumbersAt, numberOfNumbersToMake, numberOfSetsToMake){
    console.log(`printSequence(${startNumbersAt}, ${numberOfNumbersToMake}, ${numberOfSetsToMake})`)
    if(numberOfSetsToMake===undefined){
        numberOfSetsToMake=Math.floor(maxNumRowsPerPage/((numberOfNumbersToMake-1)/numberAcross));
    }
    let numberUp=Math.ceil((numberOfNumbersToMake-1)/numberAcross);
    let canvasWidth=(((octagon4+spaceBetweenNumbers)*numberAcross*2)+octagon1)+(border*(borderFactor*3));
    let canvasHeight=((octagon4+spaceBetweenNumbers)*numberUp*numberOfSetsToMake)+octagon1+spaceBetweenNumbers+(border*(borderFactor*3));
    let rowCounter=1;
    left=+(border*borderFactor)+spaceBetweenNumbers;
    top=+(border*borderFactor)+spaceBetweenNumbers;
    
    
    let result=getObjectStart(canvasWidth,canvasHeight);

    // print as many that will fit on a page
    for(let j=0;j<(numberOfSetsToMake);j++){

        let currentNumber=startNumbersAt;

        // add stickers
        for(let i=0;i<(numberOfNumbersToMake);i++){
            result+=getCell(currentNumber);
                left=left+octagon4+spaceBetweenNumbers;
            result+=getCell(currentNumber);
            currentNumber++;
            if(rowCounter<numberAcross){
                left=left+octagon4+spaceBetweenNumbers;
                rowCounter++;
            } else {
                top=top+octagon4+spaceBetweenNumbers;
                left=border*borderFactor+spaceBetweenNumbers;
                rowCounter=1;
            }
        }

    }

    result+=
    `
        </svg>
    `;
    return result;
}

export function printFromArray(array){
    console.log(`printFromArray`)

    //startNumbersAt
    let numberOfNumbersToMake=array.length;
    let numberOfSetsToMake=1;
    
    let numberUp=Math.ceil((numberOfNumbersToMake)/(numberAcross/2));
    //let canvasWidth=(((octagon4+spaceBetweenNumbers)*numberAcross*2)+octagon1)+(border*(borderFactor*3));
    let canvasWidth=
        (((octagon4+spaceBetweenNumbers)*numberAcross)+octagon1)
        +((labelWidth)*(numberAcross/2))
        +(border*borderFactor*7)
    //    ;
    let canvasHeight=((octagon4+spaceBetweenNumbers)*numberUp*numberOfSetsToMake)+octagon1+spaceBetweenNumbers+(border*(borderFactor*3));
    
    let rowCounter=1;
    left=+(border*borderFactor)+spaceBetweenNumbers;
    top=+(border*borderFactor)+spaceBetweenNumbers;
    
    
    let result=getObjectStart(canvasWidth,canvasHeight);
    let labelNumberAcross=numberAcross/2;

    // add stickers
    //let currentNumber=1;
    array.forEach(element => {
        result+=getCell(element.minor);
        left=left+octagon4+spaceBetweenNumbers;
        result+=getCell(element.minor);
        left=left+octagon4+spaceBetweenNumbers;
        result+=getLabel(element);
        //left=left+octagon4+spaceBetweenNumbers;

        //currentNumber++;
        if(rowCounter<labelNumberAcross){
            left=left+labelWidth+spaceBetweenNumbers;
            rowCounter++;
        } else {
            top=top+octagon4+spaceBetweenNumbers;
            left=border*borderFactor+spaceBetweenNumbers;
            rowCounter=1;
        }
    
    });    

    result+=
    `
        </svg>
    `;
    return result;

}

